
import { useSupabaseAuth } from './useSupabaseAuth';

export function useAuth() {
  // Directly use our new Supabase Auth hook
  return useSupabaseAuth();
}
